<template>
  <div class="res_box">
    <p class="back_box" @click="back()">
      <img src="../../../static/images/back.png" alt="" />
      {{ langtrans().fhssyy[languageIndex] }}
    </p>
    <h2>{{ langtrans().ksjy[languageIndex] }}</h2>
    <div class="step_box" v-if="!loading">
      <p>
        <b>{{ langtrans().ajxq[languageIndex] }}</b>
      </p>
      <div class="newText">
        <span>{{ langtrans().khxm[languageIndex] }}：</span
        >{{ detailData.victimList[0].obj.victimName }} &nbsp;
        <span>{{ langtrans().ajh[languageIndex] }}：</span
        >{{ detailData.obj.caseNo }}
      </div>

      <Parinf :caseid="caseid" :token="token" />

      <p>
        <b>{{ langtrans().lcsy[languageIndex] }}</b>
      </p>
      <process
        :serviceLst="stepdata.slice(1, stepdata.length)"
        :serviceIndex="stid"
        :isStartRescue="true"
      ></process>
      <div class="det_box">
        <p v-for="(v, ind) in stepdata" :key="ind" v-if="v.dict.parentId === 0">
          <b>{{ languageIndex == 0 ? v.dict.name : v.dict.nameEn }}</b>
        </p>
      </div>

      <div class="jiedianBox">
        <div class="list" v-for="(item, index) in stepdata" v-if="index != 0">
          <div class="no" v-if="item.obj.state != 1">
            <div class="top">
              <p class="iconNo">
                {{ languageIndex == 0 ? item.dict.name : item.dict.nameEn }}
              </p>
              <p class="text1" @click="st(index)">
                {{ langtrans().kscczz[languageIndex] }}
              </p>
              <p class="text1" @click="morenode1(index)">
                {{ langtrans().qtjdjl[languageIndex] }}
              </p>
            </div>
            <div class="box1" v-if="item.solutionSvrPointList">
              <p>{{ langtrans().qjtjjd[languageIndex] }}</p>
              <ul>
                <li
                  v-for="(item, index) in item.solutionSvrPointList"
                  v-if="item.description != ''"
                >
                  {{ index + 1 }}、{{
                    languageIndex == 0
                      ? setTxt(item.description, "zh")
                      : setTxt(item.description, "en")
                  }}
                </li>
              </ul>
            </div>
          </div>
          <div class="yes" v-else>
            <div class="top">
              <p class="icon">
                {{ languageIndex == 0 ? item.dict.name : item.dict.nameEn }}
              </p>
              <p
                class="text1"
                @click="
                  st1(index);
                  setSuji();
                "
              >
                {{ langtrans().xgssym[languageIndex] }}
              </p>
              <p
                class="text1"
                @click="
                  morenode1(index);
                  setSuji();
                "
              >
                {{ langtrans().xgjj[languageIndex] }}
              </p>
            </div>
            <div class="box1">
              <p>{{ langtrans().qjtjjd[languageIndex] }}</p>
              <ul>
                <li
                  v-for="(item, index) in item.solutionSvrPointList"
                  v-if="item.description != ''"
                >
                  {{ index + 1 }}、{{
                    languageIndex == 0
                      ? setTxt(item.description, "zh")
                      : setTxt(item.description, "en")
                  }}
                </li>
              </ul>
            </div>
            <div class="box1">
              <p>{{ langtrans().cczzzs[languageIndex] }}</p>
              <ul>
                <li>
                  {{
                    languageIndex == 0
                      ? setTxt(item.obj.description, "zh")
                      : setTxt(item.obj.description, "en")
                  }}
                </li>
              </ul>
            </div>
            <div class="box1">
              <p>{{ langtrans().xxgdcs[languageIndex] }}</p>
              <ul class="addfujian">
                <li v-for="item in imglist[index - 1].list" v-if="item.url">
                  <span>{{ item.description || "no name" }}</span>
                  <a
                    :href="item.url"
                    class="delete"
                    :download="item.url"
                    target="_blank"
                    >[{{ langtrans().xzz[languageIndex] }}]</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <p class="p acc">
        <span class="doc-count-tip" :class="{ 'is-warn': relatedDocCount < 5 }">
          {{ langtrans().xxgdcs[languageIndex] }}{{ relatedDocCount }}/5
        </span>
        <el-button center type="primary" @click="acc()">{{
          langtrans().jywc[languageIndex]
        }}</el-button>
        <el-button
          type="danger"
          :loading="cancelLoading"
          @click="cancelCase()"
          >{{ langtrans().ajqx[languageIndex] }}</el-button
        >
      </p>
    </div>
    <el-dialog
      :title="langtrans().ajcczz[languageIndex]"
      :visible.sync="centerDialogVisible"
      width="680px"
      append-to-body
      custom-class="attach-edit-dialog"
      @closed="resetStartAttachDialog"
    >
      <div class="attach-edit">
        <div class="attach-edit-block">
          <div class="attach-edit-label">{{ langtrans().tjcczz[languageIndex] }}</div>
          <div class="attach-edit-editor">
            <changeLanguage v-model="txt" :changeText="txt"></changeLanguage>
          </div>
        </div>
        <div class="attach-edit-block">
          <div class="attach-edit-head">
            <div class="attach-edit-label">{{ langtrans().xxgdcs[languageIndex] }}</div>
            <span
              class="attach-edit-badge"
              :class="{ 'is-warn': relatedDocCount < 5 }"
            >
              {{ langtrans().ljsxgd[languageIndex] }} {{ relatedDocCount }}/5
            </span>
          </div>
          <p class="attach-edit-tip">{{ langtrans().xgdcwts[languageIndex] }}</p>
          <div class="attach-edit-table" v-if="urllist.length">
            <div
              class="attach-edit-row"
              v-for="(item, index) in urllist"
              :key="item.url + '_' + index"
            >
              <a
                class="attach-edit-thumb"
                :href="item.url"
                target="_blank"
                :title="langtrans().xzz[languageIndex]"
              >
                <img v-if="isImageUrl(item.url)" :src="item.url" alt="" />
                <i v-else class="el-icon-document"></i>
              </a>
              <div class="attach-edit-fields">
                <span class="attach-edit-name" :title="item.description">{{
                  item.description || "no name"
                }}</span>
              </div>
              <div class="attach-edit-ops">
                <a :href="item.url" target="_blank">{{
                  langtrans().ckfj[languageIndex]
                }}</a>
                <span
                  class="attach-edit-ops-link"
                  @click="renameStartAttach(index)"
                  >{{ langtrans().xgtpmc[languageIndex] }}</span
                >
                <span
                  class="attach-edit-ops-del"
                  @click="removeStartAttach(index)"
                  >{{ langtrans().sc[languageIndex] }}</span
                >
              </div>
            </div>
          </div>
          <div class="attach-edit-empty" v-else>
            {{ langtrans().zwfjqxzj[languageIndex] }}
          </div>
          <div class="attach-edit-add">
            <el-upload
              action="#"
              multiple
              :show-file-list="false"
              :before-upload="beforeAttachUpload"
              :http-request="uploadStartAttach"
              :disabled="uploadLoading"
            >
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                :loading="uploadLoading"
                >{{ langtrans().tjfj[languageIndex] }}</el-button
              >
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{
          langtrans().qx[languageIndex]
        }}</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          :disabled="submitLoading || uploadLoading"
          @click="oknode()"
          >{{ langtrans().wcgccz[languageIndex] }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="langtrans().fjjssy[languageIndex]"
      :visible.sync="centerDialogVisible1"
      width="680px"
      append-to-body
      custom-class="attach-edit-dialog"
      @closed="resetEditAttachDialog"
    >
      <div class="attach-edit">
        <div class="attach-edit-block">
          <div class="attach-edit-label">{{ langtrans().xgcczz[languageIndex] }}</div>
          <div class="attach-edit-editor">
            <changeLanguage
              :changeText="imglistShuoming"
              v-model="imglistShuoming"
              :btn="numberIndex"
            ></changeLanguage>
          </div>
        </div>
        <div class="attach-edit-block">
          <div class="attach-edit-head">
            <div class="attach-edit-label">{{ langtrans().xxgdcs[languageIndex] }}</div>
            <span
              class="attach-edit-badge"
              :class="{ 'is-warn': relatedDocCount < 5 }"
            >
              {{ langtrans().ljsxgd[languageIndex] }} {{ relatedDocCount }}/5
            </span>
          </div>
          <p class="attach-edit-tip">{{ langtrans().xgdcwts[languageIndex] }}</p>
          <div class="attach-edit-table" v-if="editAttachList.length">
            <div
              class="attach-edit-row"
              v-for="(item, index) in editAttachList"
              :key="item.url + '_' + index"
            >
              <a
                class="attach-edit-thumb"
                :href="item.url"
                target="_blank"
                :title="langtrans().xzz[languageIndex]"
              >
                <img v-if="isImageUrl(item.url)" :src="item.url" alt="" />
                <i v-else class="el-icon-document"></i>
              </a>
              <div class="attach-edit-fields">
                <span class="attach-edit-name" :title="item.description">{{
                  item.description || "no name"
                }}</span>
              </div>
              <div class="attach-edit-ops">
                <a :href="item.url" target="_blank">{{
                  langtrans().ckfj[languageIndex]
                }}</a>
                <span
                  class="attach-edit-ops-link"
                  @click="renameEditAttach(index)"
                  >{{ langtrans().xgtpmc[languageIndex] }}</span
                >
                <span
                  class="attach-edit-ops-del"
                  @click="removeEditAttach(index)"
                  >{{ langtrans().sc[languageIndex] }}</span
                >
              </div>
            </div>
          </div>
          <div class="attach-edit-empty" v-else>
            {{ langtrans().zwfjqxzj[languageIndex] }}
          </div>
          <div class="attach-edit-add">
            <el-upload
              action="#"
              multiple
              :show-file-list="false"
              :before-upload="beforeAttachUpload"
              :http-request="uploadEditAttach"
              :disabled="uploadLoading"
            >
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                :loading="uploadLoading"
                >{{ langtrans().tjfj[languageIndex] }}</el-button
              >
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible1 = false">{{
          langtrans().qx[languageIndex]
        }}</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          :disabled="submitLoading || uploadLoading"
          @click="oknode1()"
          >{{ langtrans().wcxg[languageIndex] }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="acc_box"
      :title="langtrans().wcjyaj[languageIndex]"
      :visible.sync="isacc"
      width="1050px"
      center
    >
      <p class="text_1">
        A{{ langtrans().bjjj[languageIndex] }}
        <span class="span" v-if="this.$route.query.typeId != 800"
          >{{ langtrans().ztbtbj[languageIndex] }}
          <small v-if="flag"
            >{{ feedata.totalFee }} {{ feedata.currency || "USD" }}</small
          ></span
        >
        <span class="span"
          >{{ langtrans().jyfy[languageIndex] }}
          <small v-if="flag"
            >{{ feedata.rescueFee }} {{ feedata.currency || "USD" }}</small
          ></span
        >
        <span class="span" v-if="this.$route.query.typeId != 800"
          >{{ langtrans().ajfy[languageIndex] }}
          <small v-if="flag"
            >{{ feedata.caseFee }} {{ feedata.currency || "USD" }}</small
          ></span
        >
        <span class="span" v-if="this.$route.query.typeId != 800"
          >{{ langtrans().ylfy[languageIndex] }}
          <small v-if="flag"
            >{{ feedata.medicFee }} {{ feedata.currency || "USD" }}</small
          ></span
        >
      </p>
      <div class="p_box">
        <p class="text_1">B{{ langtrans().sjfy[languageIndex] }}</p>
        <label for="jy"
          >{{ langtrans().jyfy[languageIndex] }}:
          <input
            type="number"
            name="jy"
            id="jy"
            v-model="jytxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(jytxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
        <label for="yl" v-if="this.$route.query.typeId != 800">
          {{ langtrans().ylfy[languageIndex] }}:<input
            type="number"
            name="yl"
            id="yl"
            v-model="yltxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(yltxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
        <label for="aj" v-if="this.$route.query.typeId != 800">
          {{ langtrans().ajfy[languageIndex] }}:<input
            type="number"
            name="aj"
            id="aj"
            v-model="ajtxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(ajtxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
        <!-- <label for="aj" v-if="this.$route.query.typeId == 800">
					案件服务费用:<input type="number" name="aj" id="aj" v-model="ajtxt" :placeholder='langtrans().qsrje[languageIndex]' @input="upnum(ajtxt)">
					<span>{{feedata.currency || 'USD'}}</span>
				</label> -->
        <label for="qt" v-if="this.$route.query.typeId != 800"
          >{{ langtrans().qjtfy[languageIndex] }}:
          <input
            type="number"
            name="qt"
            id="qt"
            v-model="qttxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(qttxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
        <label for="yl" v-if="this.$route.query.typeId == 800">
          {{ langtrans().qjtfy[languageIndex] }}:<input
            type="number"
            name="yl"
            id="yl"
            v-model="yltxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(yltxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>

        <label v-if="this.$route.query.typeId != 800" for="zt" class="input">
          {{ langtrans().ztbtbj[languageIndex] }}:
          <p>{{ zttxt }}</p>
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
      </div>
      <!-- <el-input rows="3" type="textarea" :placeholder="langtrans().qjtfys[languageIndex]" v-model="qt" @input="setqt"></el-input> -->
      <p>其他费用说明</p>
      <changeLanguage v-model="qt" :changeText="qt"></changeLanguage>
      <p class="p">
        <el-button center type="primary" @click="accup()">{{
          langtrans().qrtdsj[languageIndex]
        }}</el-button>
      </p>
    </el-dialog>
    <el-dialog
      :title="langtrans().ajcczz[languageIndex]"
      :visible.sync="elseDialog"
      width="550px"
      center
    >
      <p class="node" v-for="(v, ind) in nodelist" :key="ind">
        <span>{{ langtrans().tjjjdd[languageIndex] }}</span>
        <el-input
          class="input_box"
          type="text"
          :placeholder="langtrans().qtjjjd[languageIndex]"
          v-model="v.description"
        ></el-input>
        <small
          class="add_span"
          v-if="ind == nodelist.length - 1"
          @click="addNode($event, ind)"
          ><span>+</span> {{ langtrans().tj[languageIndex] }}</small
        >
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="(elseDialog = false), upnode()">{{
          langtrans().wcgccz[languageIndex]
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="langtrans().xgjj[languageIndex]"
      :visible.sync="elseDialog1"
      width="550px"
      center
    >
      <p class="node" v-for="(item, index) in nodeArr">
        <span>{{ langtrans().xgjj[languageIndex] }} {{ index + 1 }}</span>
        <!-- <el-input class="input_box" type="text" :placeholder="langtrans().qtjjjd[languageIndex]" v-model="item.description"></el-input> -->
        <changeLanguage
          class="input_box"
          :changeText="item.description"
          v-model="item.description"
          :btn="numberIndex"
        ></changeLanguage>
        <small class="add_span"
          ><span @click="deleteNode(index)">
            {{ langtrans().sc[languageIndex] }}</span
          ></small
        >
      </p>
      <p class="node" v-for="(v, ind) in nodelist">
        <span
          >{{ langtrans().tjjjdd[languageIndex] }}
          {{ nodeArr.length + 1 + ind }}</span
        >
        <!-- <el-input class="input_box" type="text" :placeholder="langtrans().qtjjjd[languageIndex]" v-model="v.description"></el-input>-->
        <changeLanguage
          class="input_box"
          v-model="v.description"
          :changeText="v.description"
        ></changeLanguage>
        <small
          class="add_span"
          v-if="ind == nodelist.length - 1"
          @click="addNode($event, ind)"
          ><span>+</span> {{ langtrans().tj[languageIndex] }}</small
        >
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upnode1()"
          >{{ langtrans().qrxg[languageIndex] }}
        </el-button>
      </span>
    </el-dialog>

    <div class="loading" v-if="loading">
      <img src="../../../static/images/loading.gif" alt="" />
    </div>
  </div>
</template>

<script>
import Parinf from "../par/Parinf.vue";
import langtrans from "./js/resstep.vue.trans.js";
import qs from "qs";
import { Message } from "element-ui";
import constants from "@/util/constants.js";
import process from "@/components/process/index1";
import { getNodeData, getCasedetail } from "@/views/axios/api.js";
import changeLanguage from "@/components/common/changeLange.vue";
export default {
  data() {
    return {
      zttxt: "0",
      yltxt: "",
      ajtxt: "",
      jytxt: "",
      qttxt: "",
      qt: "",
      nodelist: [
        {
          description: "",
          solutionSvrId: "",
        },
      ],
      loading: true,
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data")).data,
      caseid: this.$route.query.caseid,
      stepdata: [],
      urllist: [],
      txt: "",
      txts: "",
      file: "",
      fileurl: "",
      centerDialogVisible: false,
      centerDialogVisible1: false,
      imgVisible: false,
      elseDialog: false,
      id: 0,
      stid: 0,
      num: 0,
      isacc: false,
      feedata: {},
      flag: false,
      imglist: [],
      btn_flag: false,
      serviceId: 0,
      serviceFinish: 1,
      elseDialog1: false, //修改节点
      nodeArr: [], //节点数组
      imglistFj: [], //附件数组
      imglistFj1: [], //附件数组（兼容旧逻辑）
      /** 附件及说明修改弹框中的附件列表 */
      editAttachList: [],
      imglistShuoming: "", //说明
      imgVisible1: false,
      num1: "", //index修改的第几个
      detailData: {},
      numberIndex: 0,
      /** 修改弹框上传中 */
      uploadLoading: false,
      /** 进行中的上传请求数（支持多选并发） */
      uploadPending: 0,
      /** 完成该操作/完成修改提交中 */
      submitLoading: false,
      /** 案件取消提交中 */
      cancelLoading: false,
    };
  },
  components: {
    process,
    changeLanguage,
    Parinf,
  },

  methods: {
    setSuji() {
      setTimeout(() => {
        this.numberIndex = Math.random();
      }, 400);
    },
    getdetailCase() {
      var data = {
        token: this.token,
        caseId: this.caseid,
      };
      getCasedetail(data)
        .then((res) => {
          console.log(res);
          this.detailData = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setTxt(str, status) {
      if (constants.setTxt(str, status)) {
        return constants.setTxt(str, status);
      } else {
        return str;
      }
    },
    langtrans() {
      return langtrans;
    },
    /**
     * 统计已上传且含 url 的相关单据数量
     * @param {Array<{url?: string}>} list
     * @returns {number}
     */
    countAttach(list) {
      var n = 0;
      (list || []).forEach(function (item) {
        if (item && item.url) {
          n++;
        }
      });
      return n;
    },
    /**
     * 判断附件是否为图片，便于弹框预览
     * @param {string} url
     * @returns {boolean}
     */
    isImageUrl(url) {
      if (!url) return false;
      return (
        /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i.test(url) ||
        url.indexOf("data:image") === 0
      );
    },
    /**
     * 复制节点附件，避免弹框内修改直接改到原列表
     * @param {Array<{url?: string, description?: string}>} list
     * @returns {Array<{url: string, description: string}>}
     */
    cloneAttachList(list) {
      var result = [];
      (list || []).forEach(function (item) {
        if (item && item.url) {
          result.push({
            url: item.url,
            description: item.description || "",
          });
        }
      });
      return result;
    },
    /**
     * 从开始操作弹框中删除一条附件
     * @param {number} index
     */
    removeStartAttach(index) {
      this.urllist.splice(index, 1);
    },
    /**
     * 修改开始操作弹框中的附件名称
     * @param {number} index
     */
    renameStartAttach(index) {
      this.renameAttachItem(this.urllist, index);
    },
    /**
     * 修改修改弹框中的附件名称
     * @param {number} index
     */
    renameEditAttach(index) {
      this.renameAttachItem(this.editAttachList, index);
    },
    /**
     * 弹窗修改附件名称
     * @param {Array<{description?: string}>} list
     * @param {number} index
     */
    renameAttachItem(list, index) {
      var item = list && list[index];
      if (!item) return;
      var that = this;
      this.$prompt(
        this.langtrans().qsrtpmc[this.languageIndex],
        this.langtrans().xgtpmc[this.languageIndex],
        {
          confirmButtonText: this.langtrans().qd[this.languageIndex],
          cancelButtonText: this.langtrans().qx[this.languageIndex],
          inputValue: item.description || "",
          inputValidator: function (value) {
            if (!value || !String(value).trim()) {
              return that.langtrans().tpmcbnwk[that.languageIndex];
            }
            return true;
          },
        }
      )
        .then(function (res) {
          item.description = String(res.value).trim();
        })
        .catch(function () {});
    },
    /**
     * 上传前校验：单文件不超过 20MB
     * @param {File} file
     * @returns {boolean}
     */
    beforeAttachUpload(file) {
      var maxSize = 20 * 1024 * 1024;
      if (file && file.size > maxSize) {
        Message.error(this.langtrans().dwjcg[this.languageIndex]);
        return false;
      }
      return true;
    },
    /**
     * 关闭开始操作弹框时重置上传状态
     */
    resetStartAttachDialog() {
      this.txts = "";
      this.file = "";
      this.uploadPending = 0;
      this.uploadLoading = false;
      this.submitLoading = false;
    },
    /**
     * 开始/结束一次上传，维护 loading 状态
     * @param {boolean} start
     */
    setUploadPending(start) {
      if (start) {
        this.uploadPending = this.uploadPending + 1;
      } else {
        this.uploadPending = Math.max(0, this.uploadPending - 1);
      }
      this.uploadLoading = this.uploadPending > 0;
    },
    /**
     * 上传单个附件文件
     * @param {File} file
     * @returns {Promise<{url: string, description: string}>}
     */
    uploadOneAttachFile(file) {
      var formdata = new FormData();
      formdata.append("token", this.token);
      formdata.append("file", file);
      return this.axios
        .post(constants.domain + "rescue/case/upload_file", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          return {
            url: res.data.obj,
            description: file.name,
          };
        });
    },
    /**
     * 开始操作弹框内上传附件（支持一次多选）
     * @param {{file: File}} option
     */
    uploadStartAttach(option) {
      var file = option && option.file;
      if (!file) {
        Message.error(this.langtrans().qscwj[this.languageIndex]);
        return;
      }
      if (!this.beforeAttachUpload(file)) {
        return;
      }
      this.setUploadPending(true);
      this.uploadOneAttachFile(file)
        .then((item) => {
          this.urllist.push(item);
        })
        .catch((err) => {
          console.log(err);
          Message.error(this.langtrans().scsb[this.languageIndex]);
        })
        .then(() => {
          this.setUploadPending(false);
        });
    },
    /**
     * 从修改弹框中删除一条附件
     * @param {number} index
     */
    removeEditAttach(index) {
      this.editAttachList.splice(index, 1);
    },
    /**
     * 关闭修改弹框时重置上传状态
     */
    resetEditAttachDialog() {
      this.txts = "";
      this.file = "";
      this.uploadPending = 0;
      this.uploadLoading = false;
      this.submitLoading = false;
    },
    /**
     * 修改弹框内上传附件（支持一次多选）
     * @param {{file: File}} option
     */
    uploadEditAttach(option) {
      var file = option && option.file;
      if (!file) {
        Message.error(this.langtrans().qscwj[this.languageIndex]);
        return;
      }
      if (!this.beforeAttachUpload(file)) {
        return;
      }
      this.setUploadPending(true);
      this.uploadOneAttachFile(file)
        .then((item) => {
          this.editAttachList.push(item);
        })
        .catch((err) => {
          console.log(err);
          Message.error(this.langtrans().scsb[this.languageIndex]);
        })
        .then(() => {
          this.setUploadPending(false);
        });
    },
    upnode() {
      let nlst = this.nodelist.slice();
      if (nlst.length < 5) {
        this.axios
          .post(
            constants.domain + "rescue/case/create_svr_point",
            qs.stringify({
              token: this.token,
              solutionSvrPoints: JSON.stringify(nlst),
              //								id
            })
          )
          .then((res) => {
            console.log(res);
            if (res.data.msg == "ok") {
              this.$message({
                message: this.langtrans().tjjjdcg[this.languageIndex],
                type: "success",
              });
              this.getNodeData();
            }
            window.location.reload();
          });
      } else {
        Message.error(this.langtrans().qbbfyy[this.languageIndex]);
      }
    },
    upnode1(i) {
      if (this.nodelist[this.nodelist.length - 1].description != "") {
        this.nodeArr = [...this.nodeArr, ...this.nodelist];
      }
      if (this.nodeArr.length == 0) {
        this.nodeArr = this.nodelist;
      }
      var btn = false;
      this.nodeArr.forEach((item) => {
        if (item.description == "") {
          btn = true;
        }
      });
      if (btn)
        return Message.error(this.langtrans().jjddmc[this.languageIndex]);
      let nlst = this.nodeArr.slice();
      if (nlst.length < 10) {
        this.axios
          .post(
            constants.domain + "rescue/case/create_svr_point",
            qs.stringify({
              token: this.token,
              solutionSvrPoints: JSON.stringify(nlst),
            })
          )
          .then((res) => {
            if (res.data.msg == "ok") {
              this.$message({
                message: this.langtrans().tjjjdcg[this.languageIndex],
                type: "success",
              });
            }
            window.location.reload();
          });
      } else {
        Message.error(this.langtrans().qbbfyy[this.languageIndex]);
      }
    },
    addNode(e, i) {
      let parent = e.target.parentNode;
      this.nodelist.push({
        description: "",
        solutionSvrId: this.serviceId,
      });
    },
    morenode(i) {
      this.serviceId = this.stepdata[i].obj.id;
      this.elseDialog = true;
      for (var j = 0; j < this.nodelist.length; ++j) {
        if (this.nodelist[j].solutionSvrId != this.serviceId) {
          this.nodelist = [
            {
              solutionSvrId: this.serviceId,
              description: "",
            },
          ];
          return;
        }
      }
    },
    morenode1(index) {
      //修改节点
      this.elseDialog1 = true;
      this.serviceId = this.stepdata[index].obj.id;
      this.nodeArr = this.stepdata[index].solutionSvrPointList;
      for (var j = 0; j < this.nodelist.length; ++j) {
        if (this.nodelist[j].solutionSvrId != this.serviceId) {
          this.nodelist = [
            {
              solutionSvrId: this.serviceId,
              description: "",
            },
          ];
          return;
        }
      }
    },
    upnum(val) {
      if (isNaN(val)) {
        Message.error(this.langtrans().qsrsss[this.languageIndex]); //请输入数字，而非其他
      } else {
        if (!this.jytxt) {
          this.jytxt = 0;
        }
        if (!this.yltxt) {
          this.yltxt = 0;
        }
        if (!this.ajtxt) {
          this.ajtxt = 0;
        }
        if (!this.qttxt) {
          this.qttxt = 0;
        }
        this.jytxt = this.jytxt * 1;
        this.yltxt = this.yltxt * 1;
        this.ajtxt = this.ajtxt * 1;
        this.qttxt = this.qttxt * 1;
        this.zttxt = Number(
          this.jytxt + this.yltxt + this.ajtxt + this.qttxt
        ).toFixed(2);
      }
    },
    accup() {
      let that = this;
      if (that.serviceFinish == 0) {
        Message.error(this.langtrans().qwcsyy[this.languageIndex]); //请完成所有操作！qwcsyy
        return;
      }
      if (!this.jytxt) {
        this.jytxt = 0;
      }
      if (!this.yltxt) {
        this.yltxt = 0;
      }
      if (!this.ajtxt) {
        this.ajtxt = 0;
      }
      if (!this.qttxt) {
        this.qttxt = 0;
      }
      // if(this.zttxt == 0) {
      // 	Message.error(this.langtrans().qsrje[this.languageIndex]);//请输入金额
      // 	return;
      // }
      this.axios
        .post(
          constants.domain + "rescue/case/finish",
          qs.stringify({
            token: this.token,
            id: this.caseid,
            totalFee: Number(this.zttxt).toFixed(2),
            rescueFee: Number(this.jytxt).toFixed(2),
            medicFee: Number(this.yltxt).toFixed(2),
            caseFee: Number(this.ajtxt).toFixed(2),
            otherFee: Number(this.qttxt).toFixed(2),
            otherFeeDesc: this.qt,
          })
        )
        .then((res) => {
          if (res.data.code === 0) {
            this.isacc = false;
            this.$router.push({
              name: "Finishparinf",
              params: {
                token: this.$route.token,
              },
              query: {
                typeId: this.$route.query.typeId,
                caseid: this.$route.query.caseid,
              },
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 取消案件：调用 finish 接口，费用全部传 0
     */
    cancelCase() {
      var that = this;
      this.$confirm(this.langtrans().qrajqx[this.languageIndex], this.langtrans().ajqx[this.languageIndex], {
        type: "warning",
        confirmButtonText: this.langtrans().qd[this.languageIndex],
        cancelButtonText: this.langtrans().qx[this.languageIndex],
      })
        .then(function () {
          that.cancelLoading = true;
          that.axios
            .post(
              constants.domain + "rescue/case/finish",
              qs.stringify({
                token: that.token,
                id: that.caseid,
                totalFee: 0,
                rescueFee: 0,
                medicFee: 0,
                caseFee: 0,
                otherFee: 0,
                type:'-1'
              })
            )
            .then(function (res) {
              that.cancelLoading = false;
              if (res.data.code === 0) {
                that.$router.push({
                  name: "Finishparinf",
                  params: {
                    token: that.$route.token,
                  },
                  query: {
                    typeId: that.$route.query.typeId,
                    caseid: that.$route.query.caseid,
                  },
                });
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {
              that.cancelLoading = false;
              console.log(err);
            });
        })
        .catch(function () {});
    },
    setqt() {},
    getdata() {},
    acc() {
      if (this.serviceFinish == 0) {
        Message.error(this.langtrans().qwcsyy[this.languageIndex]); //请完成所有操作
        return;
      }
      if (this.relatedDocCount < 5) {
        Message.error(this.langtrans().xgdcwts[this.languageIndex]);
        return;
      }
      this.isacc = true;
    },
    test() {
      let tUploadCnts = this.imglist.slice();
      console.log("test:" + JSON.stringify(tUploadCnts));
    },
    oknode() {
      if (this.submitLoading || this.uploadLoading) return;
      var tUploadCnts = this.urllist.filter(function (item) {
        return item && item.url;
      });
      var obj = Object.assign({}, this.stepdata[this.num].obj);
      obj.tUploadCnts = JSON.stringify(tUploadCnts);
      obj.description = this.txt;
      obj.token = this.token;
      if (this.txt == "" && tUploadCnts.length == 0)
        return Message.error(this.langtrans().nrbbfn[this.languageIndex]);
      this.submitLoading = true;
      this.axios
        .post(
          constants.domain + "rescue/case/conclude_phase",
          qs.stringify(obj)
        )
        .then((res) => {
          if (res.data.msg == "ok") {
            this.$message({
              message: this.langtrans().tjcg[this.languageIndex],
              type: "success",
            });
            window.location.reload();
          } else {
            this.submitLoading = false;
            if (res.data.msg) {
              Message.error(res.data.msg);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.submitLoading = false;
        });
    },
    oknode1() {
      if (this.submitLoading || this.uploadLoading) return;
      var tUploadCnts = this.editAttachList.filter(function (item) {
        return item && item.url;
      });
      var obj = Object.assign({}, this.stepdata[this.num1].obj);
      obj.tUploadCnts = JSON.stringify(tUploadCnts);
      obj.description = this.imglistShuoming;
      obj.token = this.token;
      this.submitLoading = true;
      this.axios
        .post(
          constants.domain + "rescue/case/conclude_phase",
          qs.stringify(obj)
        )
        .then((res) => {
          if (res.data.msg == "ok") {
            this.$message({
              message: this.langtrans().tjcg[this.languageIndex],
              type: "success",
            });
            window.location.reload();
          } else {
            this.submitLoading = false;
            if (res.data.msg) {
              Message.error(res.data.msg);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.submitLoading = false;
        });
    },
    hendnode(e) {
      console.log(e.target);
    },
    dialogImageUrl() {},
    dialogVisible() {},
    st(i) {
      this.num = i;
      this.id = this.stepdata[i].obj.serviceId;
      this.txt = "";
      this.urllist = [];
      this.centerDialogVisible = true;
    },
    st1(i) {
      this.num1 = i;
      var source =
        this.imglist[i - 1] && this.imglist[i - 1].list
          ? this.imglist[i - 1].list
          : [];
      this.editAttachList = this.cloneAttachList(source);
      this.imglistFj1 = this.editAttachList;
      this.imglistShuoming = this.stepdata[i].obj.description;
      this.txts = "";
      this.centerDialogVisible1 = true;
    },
    back() {
      this.$router.push({
        name: "Rescue",
        params: {
          token:
            this.$route.params.token ||
            JSON.parse(window.localStorage.getItem("data")).data,
        },
        query: {
          typeId: this.$route.query.typeId,
        },
      });
    },
    getNodeData() {
      var data = {
        token: this.token,
        caseId: this.caseid,
      };
      getNodeData(data).then((res) => {
        this.flag = true;
        this.feedata = res.data.obj;
        this.stepdata = res.data.obj2;
        let n = 0;
        let arr = [];
        this.stepdata.map((v, i) => {
          arr.push(v.obj.state);
          if (v.dict.parentId != 0) {
            if (v.obj.state && v.obj.state == 1) {
              this.stid = i;
              console.log(v.obj.state);
            } else {
              this.serviceFinish = 0;
            }
          }
          if (i != 0) {
            this.imglist.push({
              list: v.uploadCntList,
            });
            if (v.uploadCntList.length > 0) {
              this.num = i;
            }
          }
        });
        for (let index = 0; index < arr.length; index++) {
          if (arr[index] != 0) {
          } else {
            n = index + 1;
          }
        }
        if (n == 0) {
          this.btn_flag = true;
        }
        this.loading = false;
      });
    },
    deleteNode(i) {
      this.nodeArr.splice(i, 1);
    },
  },
  computed: {
    languageIndex() {
      return this.$store.state.language;
    },
    /**
     * 全部节点已上传相关单据数量（开始操作/修改弹框打开时计入当前编辑列表）
     * @returns {number}
     */
    relatedDocCount() {
      var count = 0;
      var list = this.imglist || [];
      var editingIndex = this.centerDialogVisible1 ? this.num1 - 1 : -1;
      for (var i = 0; i < list.length; i++) {
        if (i === editingIndex) {
          continue;
        }
        count += this.countAttach(list[i] && list[i].list);
      }
      if (this.centerDialogVisible1) {
        count += this.countAttach(this.editAttachList);
      }
      if (this.centerDialogVisible) {
        count += this.countAttach(this.urllist);
      }
      return count;
    },
  },
  mounted() {
    this.getNodeData();
    this.getdetailCase();
    // if(this.$route.query.typeId == 800) {
    //   this.ajtxt = 70;
    //   this.zttxt = 70
    // }
  },
};
</script>

<style scoped>
@import url("../../css/resstep.css");
.jiedianBox {
  margin-left: 50px;
  margin-top: 20px;
}
.jiedianBox .list {
  margin-bottom: 20px;
}
.jiedianBox .list .top {
  overflow: hidden;
}
.jiedianBox .list .top p {
  float: left;
  margin-right: 200px;
}
.jiedianBox .list .top p.text1 {
  color: #00abfa;
  margin-right: 0;
  margin-left: 20px;
  cursor: pointer;
}
.jiedianBox .list .top p.icon {
  background: url("./../../assets/img/checkyes.png") left center no-repeat;
  padding-left: 20px;
  background-size: 16px;
  min-width: 250px;
}
.jiedianBox .list .top p.iconNo {
  background: url("./../../assets/img/checkno.png") left center no-repeat;
  padding-left: 23px;
  background-size: 16px;
  min-width: 250px;
}
.jiedianBox .list .box1 {
  margin-top: 10px;
  margin-left: 30px;
  overflow: hidden;
}
.jiedianBox .list .box1 ul {
  float: left;
  color: #999;
}
.jiedianBox .list .box1 p {
  float: left;
  line-height: 30px;
}
.jiedianBox .list .box1 li {
  line-height: 30px;
}
.addfujian li {
  background: url("../../../static/images/fj.png") no-repeat left center;
  padding-left: 20px;
  cursor: pointer;
  margin-bottom: 10px;
  line-height: 30px;
  margin-right: 150px;
}
.addfujian li span {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}
.addfujian li.add {
  color: #00abfa;
}
.addfujian li .delete {
  color: #00abfa;
  margin-left: 10px;
  text-decoration: none;
}
.node {
  margin-bottom: 10px;
}
.el-dialog.el-dialog--center ul {
  overflow: hidden;
}
.el-dialog.el-dialog--center ul {
  margin-top: 10px;
}
.el-dialog.el-dialog--center ul li {
  float: left;
  margin-right: 10px;
}
.el-dialog.el-dialog--center ul li img {
  width: 60px;
  height: 60px;
}
.el-dialog.el-dialog--center ul li p {
  text-align: center;
  line-height: 30px;
}
.el-dialog.el-dialog--center ul li .text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.acc_box .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
}
.acc_box .el-dialog__body {
  padding-top: 0 !important;
}
.text_1 {
  font-size: 16px;
}
.text_1 span {
  margin-right: 40px;
}
.p_box {
  overflow: hidden;
}
.p_box input {
  padding-left: 10px;
  outline: none;
  height: 25px;
  width: 200px;
}
.p_box label {
  position: relative;
}
.p_box label span {
  position: absolute;
  right: 5px;
  top: 5px;
}
.p_box label.input span {
  position: static;
}
label.input p {
  display: inline-block;
  padding-right: 10px;
}
.input_box {
  display: inline-block;
}
.newText {
  margin: 15px 0;
  margin-left: 40px;
}
.newText span {
  font-weight: 600;
}
.p.acc {
  position: relative;
}
.doc-count-tip {
  display: inline-block;
  margin-right: 12px;
  color: #67c23a;
  font-size: 14px;
  vertical-align: middle;
}
.doc-count-tip.is-warn {
  color: #f56c6c;
}
.p.acc .el-button {
  margin: 0 8px;
}
</style>
<style>
.attach-edit-dialog {
  text-align: left;
}
.attach-edit-dialog .el-dialog__header {
  padding: 16px 20px 10px;
  border-bottom: 1px solid #ebeef5;
}
.attach-edit-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.attach-edit-dialog .el-dialog__body {
  padding: 16px 20px;
}
.attach-edit-dialog .el-dialog__footer {
  padding: 10px 20px 16px;
  border-top: 1px solid #ebeef5;
}
.attach-edit-dialog .el-dialog__body .el-input {
  width: 100%;
  margin-left: 0;
}
.attach-edit {
  text-align: left;
}
.attach-edit-block {
  margin-bottom: 16px;
  padding: 14px 16px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}
.attach-edit-block:last-child {
  margin-bottom: 0;
}
.attach-edit-label {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  line-height: 22px;
}
.attach-edit-editor {
  margin-top: 10px;
}
.attach-edit-editor .changeBox .text {
  width: 100%;
  box-sizing: border-box;
  min-height: 88px;
}
.attach-edit-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.attach-edit-badge {
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  border-radius: 11px;
  background: #f0f9eb;
  color: #67c23a;
  font-size: 12px;
}
.attach-edit-badge.is-warn {
  background: #fef0f0;
  color: #f56c6c;
}
.attach-edit-tip {
  margin: 8px 0 12px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.attach-edit-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
}
.attach-edit-row {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #ebeef5;
}
.attach-edit-row:last-child {
  border-bottom: 0;
}
.attach-edit-thumb {
  width: 44px;
  height: 44px;
  margin-right: 12px;
  flex-shrink: 0;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #909399;
  font-size: 18px;
}
.attach-edit-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.attach-edit-fields {
  flex: 1;
  min-width: 0;
}
.attach-edit-name {
  display: block;
  color: #303133;
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.attach-edit-ops {
  display: flex;
  align-items: center;
  margin-left: 12px;
  flex-shrink: 0;
  white-space: nowrap;
}
.attach-edit-ops a,
.attach-edit-ops span {
  font-size: 13px;
  cursor: pointer;
  margin-left: 12px;
}
.attach-edit-ops a,
.attach-edit-ops-link {
  color: #409eff;
}
.attach-edit-ops a:first-child,
.attach-edit-ops span:first-child {
  margin-left: 0;
}
.attach-edit-ops-del {
  color: #f56c6c;
}
.attach-edit-empty {
  padding: 18px 0;
  text-align: center;
  color: #c0c4cc;
  font-size: 13px;
  background: #fff;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.attach-edit-add {
  margin-top: 12px;
  text-align: left;
}
.attach-edit-add .el-upload {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/fac/resstep.vue